// extracted by mini-css-extract-plugin
export default {"card":"fWXYiydi","noPadding":"GGQb6mSm","title":"Viv9WwYc"};